import { Button } from "components/DesignSystem/Button/Button";
import ChatCard from "components/DesignSystem/ChatCard/ChatCard";
import { ReviewDocHeader } from "components/icons/ReviewDocHeader";
import { ReviewDraftFiling } from "components/MessageBubble/ReviewDraftFiling";
import { useModal } from "hooks/useModal";
import { FilingDraftCardBody } from "./FilingDraftCardBody";
import { SUBMITTED } from "constants/sensitiveData";

type FilingDraftCardCustomData = {
  cta_data: null;
  card_status: string;
  metadata: {
    is_approved: boolean | null;
    review_draft_id: string;
    file_id: string;
    rejection_reason: string;
    submitted_by: { uuid: string; name: string } | null;
  };
};

export const FilingDraftCard = ({
  customData,
  groupId,
  size,
}: {
  customData: FilingDraftCardCustomData;
  groupId: string;
  size?: "regular" | "block";
}) => {
  const draftId = customData?.metadata?.review_draft_id;
  const isSubmitted = customData.card_status === SUBMITTED;
  const reviewDraftModal = useModal();

  return (
    <div className="t-min-w-72 sm:t-min-w-0">
      <ChatCard.Root size={size}>
        <ChatCard.Header>
          <div className="t-gap-1.5 t-flex t-items-center">
            <ReviewDocHeader />
            Review Draft
          </div>
        </ChatCard.Header>
        <ChatCard.Body>
          <FilingDraftCardBody
            approveStatus={customData?.metadata?.is_approved}
            groupId={groupId}
            fileId={customData?.metadata?.file_id}
            rejectionReason={customData?.metadata?.rejection_reason || ""}
          />
          {isSubmitted ? (
            <Button size="small" onClick={reviewDraftModal.open}>
              View
            </Button>
          ) : (
            <Button
              size="small"
              customType="primary"
              onClick={reviewDraftModal.open}
            >
              Review
            </Button>
          )}
        </ChatCard.Body>
        {reviewDraftModal.isOpen && (
          <ReviewDraftFiling
            {...reviewDraftModal}
            draftId={draftId}
            groupId={groupId}
            isSubmitted={isSubmitted}
            rejectionReason={customData?.metadata?.rejection_reason || ""}
            approvalStatus={customData?.metadata?.is_approved}
            submittedBy={customData?.metadata?.submitted_by?.name || null}
          />
        )}
      </ChatCard.Root>
    </div>
  );
};
